import { Loader2, RefreshCw } from "lucide-react";
import { Panel, InlineWarning } from "@/components/common/Primitives";
import { Co2SourcePanel } from "@/components/explain/ExplainDialogs";
import { inputCls } from "@/components/vehicle/constants";

const MANUAL_FIELDS = [
  ["source_name", "Bron", "manual-co2-source", "bijv. kentekenbewijs, RDW, fabrikant"],
  ["source_url", "Bron-URL", "manual-co2-url", "https://"],
];

export const Co2Panel = ({
  analysis,
  co2Msg,
  co2Busy,
  enrichCo2,
  manual,
  setManual,
  showManual,
  setShowManual,
  saveManualCo2,
  onOpenBpm,
}) => (
  <Panel
    title="CO₂-bron"
    subtitle="Elke waarde is herleidbaar naar een bron — nooit geraden"
    testid="co2-panel"
    actions={
      <button
        type="button"
        onClick={onOpenBpm}
        data-testid="open-co2-source"
        className="rounded-sm border border-slate-300 px-2 py-1 text-[11px] font-semibold text-slate-700 hover:bg-slate-50"
      >
        CO₂ bron bekijken
      </button>
    }
  >
    <div className="space-y-2 p-3">
      {co2Msg && (
        <InlineWarning tone="info" testid="co2-message">
          {co2Msg}
        </InlineWarning>
      )}
      <Co2SourcePanel co2={analysis?.co2} bpm={analysis?.bpm} compact />
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => enrichCo2(true)}
          disabled={co2Busy === "enrich"}
          data-testid="enrich-co2-button"
          className="flex items-center gap-1.5 rounded-sm bg-slate-900 px-2.5 py-1.5 text-[12px] font-semibold text-white hover:bg-slate-700 disabled:opacity-60"
        >
          {co2Busy === "enrich" ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <RefreshCw className="h-3.5 w-3.5" />
          )}
          CO₂ opnieuw zoeken
        </button>
        <button
          type="button"
          onClick={() => setShowManual((s) => !s)}
          data-testid="toggle-manual-co2"
          className="rounded-sm border border-slate-300 px-2.5 py-1.5 text-[12px] font-semibold text-slate-700 hover:bg-slate-50"
        >
          Handmatig invoeren
        </button>
      </div>
      {showManual && (
        <div className="grid grid-cols-2 gap-2 border-t border-slate-100 pt-2">
          <div>
            <label className="label-xs">CO₂ (g/km)</label>
            <input
              type="number"
              value={manual.co2_value}
              onChange={(e) => setManual((m) => ({ ...m, co2_value: e.target.value }))}
              data-testid="manual-co2-value"
              className={inputCls}
            />
          </div>
          <div>
            <label className="label-xs">Meetmethode</label>
            <select
              value={manual.measurement_method}
              onChange={(e) => setManual((m) => ({ ...m, measurement_method: e.target.value }))}
              data-testid="manual-co2-method"
              className={inputCls}
            >
              <option value="WLTP">WLTP</option>
              <option value="NEDC">NEDC</option>
              <option value="NEDC_CORRELATED">NEDC correlated</option>
            </select>
          </div>
          {MANUAL_FIELDS.map(([key, label, testid, placeholder]) => (
            <div key={key}>
              <label className="label-xs">{label}</label>
              <input
                value={manual[key]}
                onChange={(e) => setManual((m) => ({ ...m, [key]: e.target.value }))}
                data-testid={testid}
                className={inputCls}
                placeholder={placeholder}
              />
            </div>
          ))}
          <div className="col-span-2">
            <label className="label-xs">Notitie</label>
            <input
              value={manual.note}
              onChange={(e) => setManual((m) => ({ ...m, note: e.target.value }))}
              data-testid="manual-co2-note"
              className={inputCls}
            />
          </div>
          <div className="col-span-2">
            <button
              type="button"
              onClick={saveManualCo2}
              disabled={co2Busy === "manual" || !manual.co2_value || !manual.source_name}
              data-testid="save-manual-co2"
              className="flex items-center gap-1.5 rounded-sm bg-blue-600 px-3 py-1.5 text-[12px] font-semibold text-white hover:bg-blue-700 disabled:opacity-60"
            >
              {co2Busy === "manual" && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
              Opslaan als MANUAL OVERRIDE
            </button>
          </div>
        </div>
      )}
    </div>
  </Panel>
);
